import _ from 'lodash';
import React, { ComponentType } from 'react';
import { TemplateCardProps } from '../TemplateCard/TemplateCard';
import { TemplateGalleryCard } from '@common/types';

export type TemplateListCardComponentProps = Pick<
  TemplateCardProps,
  | 'actionButton'
  | 'actionButtonVisibility'
  | 'overlayContent'
  | 'forceRender'
  | 'index'
  | 'template'
> & {
  isMobileView?: boolean;
  cardActions?: React.ReactElement;
  entryParam?: string;
  onCustomClick?: () => void;
};

export type ITemplateListCardComponent =
  ComponentType<TemplateListCardComponentProps>;

export type Props = {
  templates?: TemplateGalleryCard[];
  isMobileView: boolean;
  SSRFlow?: boolean;
  CardComponent: ITemplateListCardComponent;
  LoadingState: ComponentType<{ isMobileView?: boolean }>;
  getActionButton?: (template: TemplateGalleryCard) => React.ReactNode;
  actionButtonVisibility?: TemplateCardProps['actionButtonVisibility'];
  getOverlayContent?: (
    template: TemplateGalleryCard,
  ) => React.ReactElement | undefined;
  getCardActions?: (
    template: TemplateGalleryCard,
  ) => React.ReactElement | undefined;
  getCardOnClick?: (template: TemplateGalleryCard) => (() => void) | undefined;
  cardEntryParam?: string;
};

const TemplateCardListItems = ({
  templates,
  isMobileView,
  SSRFlow,
  CardComponent,
  LoadingState,
  getActionButton,
  actionButtonVisibility,
  getOverlayContent,
  getCardActions,
  getCardOnClick,
  cardEntryParam,
}: Props) => {
  const haveTemplates = _.size(templates) > 0;

  if (haveTemplates) {
    return (
      <>
        {_.map(templates, (template, index) => (
          <li key={template.id}>
            <CardComponent
              isMobileView={isMobileView}
              template={template}
              forceRender={SSRFlow}
              index={index}
              actionButton={getActionButton?.(template)}
              actionButtonVisibility={actionButtonVisibility}
              overlayContent={getOverlayContent?.(template)}
              cardActions={getCardActions?.(template)}
              onCustomClick={getCardOnClick?.(template)}
              entryParam={cardEntryParam}
            />
          </li>
        ))}
      </>
    );
  }

  return <LoadingState isMobileView={isMobileView} />;
};

export default TemplateCardListItems;
